<template>
  <div class="full">
    <div v-if="!showedEntreprises && !firstDomain" class="container-bubble">
      <bubble
        v-for="domain in domainsForFirstStep"
        :secteur="domain"
        :key="domain.id"
        :minEntreprise="minEntreprise"
        :maxEntreprise="maxEntreprise"
        @click.native="clickOnFirstLevelDomain(domain)"
      />
    </div>
    <div v-if="!showedEntreprises && firstDomain" >
      <div class="btn-retour">
        <span @click="goBack"><img src="https://i.ya-webdesign.com/images/right-arrow-white-png-2.png" alt="">
          Retour
        </span>
        <span>{{ firstDomain.x_name }}</span>
      </div>
      <div class="container-bubble">
        <bubble
            v-for="domain in domainsForSecondStep"
            :secteur="domain"
            :key="domain.id"
            :minEntreprise="minEntreprise2"
            :maxEntreprise="maxEntreprise2"
            @click.native="clickOnSecondLevelDomain(domain)"
        />
      </div>
    </div>

    <div v-if="showedEntreprises">
      <div class="btn-retour">
        <span @click="goBack"><img src="https://i.ya-webdesign.com/images/right-arrow-white-png-2.png" alt=""> Retour</span>
        <span>{{ firstDomain.x_name }} / {{ secondDomain.x_name }}</span>
      </div>
      <entreprise v-for="currentEntreprise in currentEntreprises" :key="currentEntreprise.id" :entreprise="currentEntreprise"/>
    </div>
  </div>
</template>

<script>
import Bubble from './Bubble'
import Entreprise from './Entreprise'

export default {
  name: 'Domain',
  components : {
    Bubble,
    Entreprise
  },
  data: function () {
    return {
        minEntreprise: 100000,
        maxEntreprise: null,
        minEntreprise2: 100000,
        maxEntreprise2: null,
        currentEntreprises: [],
        showedEntreprises : false,
        firstDomain: null,
        secondDomain: null,
        domainsForFirstStep: [],
        domainsForSecondStep: [],
    }
  },
  props: ['domains', 'entreprises', 'secteurs'],
  mounted() {

    if (this.entreprises && this.domains) {
      this.entreprises.forEach(entreprise => {
        if (entreprise.x_cartoia_classification_1) {
          if (!this.domainsForFirstStep.find(d => d.id === entreprise.x_cartoia_classification_1[0])) {
            this.domainsForFirstStep.push({
              id: entreprise.x_cartoia_classification_1[0],
              x_name: entreprise.x_cartoia_classification_1[1],
              entreprises: [entreprise]
            })
          }
          else {
            this.domainsForFirstStep.find(d => d.id === entreprise.x_cartoia_classification_1[0]).entreprises.push(entreprise)
          }
        }
        if (entreprise.x_cartoia_classification_2) {
          if (!this.domainsForFirstStep.find(d => d.id === entreprise.x_cartoia_classification_2[0])) {
            this.domainsForFirstStep.push({
              id: entreprise.x_cartoia_classification_2[0],
              x_name: entreprise.x_cartoia_classification_2[1],
              entreprises: [entreprise]
            })
          }
          else {
            this.domainsForFirstStep.find(d => d.id === entreprise.x_cartoia_classification_2[0]).entreprises.push(entreprise)
          }
        }
      })

      this.domainsForFirstStep.sort((a, b) => (a.x_name > b.x_name) ? 1 : -1)

      const indexToMoveAtTheEnd = this.domainsForFirstStep.findIndex(d => d.id === 713)
      if (indexToMoveAtTheEnd) this.domainsForFirstStep.push(this.domainsForFirstStep.splice(indexToMoveAtTheEnd, 1)[0])

      this.domainsForFirstStep.forEach(domain => {
        const countEntreprises = domain.entreprises.length
        if (countEntreprises >= this.maxEntreprise) {
          this.maxEntreprise = countEntreprises
        }
        if (countEntreprises <= this.minEntreprise) {
          this.minEntreprise = countEntreprises
        }
      })

    }

  },
  methods: {
    clickOnFirstLevelDomain(domain) {
      this.$emit('activeSplashScreen')
      this.secteurs.forEach(secteur => secteur.entreprises = [])
      this.domainsForSecondStep = this.secteurs
      this.firstDomain = domain
      domain.entreprises.forEach(entreprise => {
        const secteursForCompany = entreprise.x_cartoia_targetsectior
        if (secteursForCompany.length > 0) {
          this.domainsForSecondStep
            .filter(s => secteursForCompany.includes(s.id))
            .map(s => s.entreprises.push(entreprise))
        }
      })
      this.domainsForSecondStep = this.domainsForSecondStep.filter(s => s.entreprises && s.entreprises.length > 0)

      this.domainsForSecondStep.sort((a, b) => (a.x_name > b.x_name) ? 1 : -1)

      this.domainsForSecondStep.forEach(secteur => {
        const countEntreprises = secteur.entreprises.length
        if (countEntreprises >= this.maxEntreprise2) {
          this.maxEntreprise2 = countEntreprises
        }
        if (countEntreprises <= this.minEntreprise2) {
          this.minEntreprise2 = countEntreprises
        }
      })

      if(this.domainsForSecondStep.length === 1) {
        this.clickOnSecondLevelDomain(this.domainsForSecondStep[0])
      }
    },
    clickOnSecondLevelDomain(domain) {
      this.$emit('activeSplashScreen')
      this.secondDomain = domain
      this.currentEntreprises = domain.entreprises
      this.showedEntreprises = true
    },
    goBack() {
      this.$emit('activeSplashScreen')
      if (this.showedEntreprises) {
        this.currentEntreprises = []
        this.showedEntreprises = false
        this.secondDomain = false
        if(this.domainsForSecondStep.length === 1) {
          this.firstDomain = false
          this.domainsForSecondStep = []
        }
      }
      else {
        this.firstDomain = false
        this.domainsForSecondStep = []
      }
    }
  }
}
</script>